import { AppMetadata, Auth0Identity, User, UserMetadata } from '@/../types/interfaces';
import { RoleName } from '@/../types/enums';
import { FrontEndModel } from '../FrontEndModel';

export class UserModel extends FrontEndModel implements User {
	roles: RoleName[];
	email: string;
	email_verified: boolean;
	app_metadata?: AppMetadata;
	user_metadata?: UserMetadata;
	identities?: Auth0Identity[];
	pictureUrl: string;
	firstName: string;
	lastName: string;
	groups: string[];
	athleteId?: string;
	coachId?: string;
}